/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `alloy` - ALLOY
 * * `ash` - ASH
 * * `ballad` - BALLAD
 * * `cedar` - CEDAR
 * * `coral` - CORAL
 * * `echo` - ECHO
 * * `fable` - FABLE
 * * `marin` - MARIN
 * * `nova` - NOVA
 * * `onyx` - ONYX
 * * `sage` - SAGE
 * * `shimmer` - SHIMMER
 * * `verse` - VERSE
 */
export enum AiVoice {
  ALLOY = 'alloy',
  ASH = 'ash',
  BALLAD = 'ballad',
  CEDAR = 'cedar',
  CORAL = 'coral',
  ECHO = 'echo',
  FABLE = 'fable',
  MARIN = 'marin',
  NOVA = 'nova',
  ONYX = 'onyx',
  SAGE = 'sage',
  SHIMMER = 'shimmer',
  VERSE = 'verse',
}
